<template>
  <tags-list />
</template>

<script>
import tagsList from '@/components/lists/tags/tagsList'

export default {
    components: {
        tagsList,
    },
}
</script>
